import { Component, Vue } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import { LanguageCodeEnum, languagesList } from "@/i18n";
import { BFormSelect } from "@/lib/typed-bootstrap";

import styles from "./LangSelect.component.module.scss";

@Component
export default class LangSelect extends Vue {
  _tsx!: tsx.DeclareProps<{}> & tsx.DeclareOnEvents<{}>;

  languages = languagesList.map((locale) => ({
    value: locale.code,
    text: locale.name,
  }));

  onSelect(val: LanguageCodeEnum) {
    this.$i18n.locale = val;
  }

  render() {
    return (
      <BFormSelect
        class={styles.select}
        size="sm"
        options={this.languages}
        value={this.$i18n.locale}
        onInput={(val: LanguageCodeEnum) => this.onSelect(val)}
      />
    );
  }
}
